<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#08A762', color: '#ffffff' }"
    :class="buttonClass"
    @click="openModal(FIX_ERRORS_MODAL)"
  >
    <i class="fa fa-list" />
    Fix Errors
  </b-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { FIX_ERRORS_MODAL } from '@/const/ModalTypes'
import { openModal } from '@/services/Modal'

export default defineComponent({
  name: 'FixErrors',
  props: {
    buttonClass: {
      type: String,
      default: 'ml-3',
    },
  },
  setup() {
    return {
      openModal,
      FIX_ERRORS_MODAL,
    }
  },
})
</script>
